import { __rest } from "tslib";
import { useField } from 'formik';
import * as React from 'react';
import { IconButton } from '../../icon-button';
import { FieldErrorMessageWrapper, InputStepperWrapper, LabelSupportingTextWrapper, StyledInputStepper, StyledInternalTextInput, StyledLabel, StyledMinusButton, StyledPlusButton, StyledSupportingLabel, } from './InputStepper.styled';
export const InputStepper = (_a) => {
    var { incrementAmount = 1, minValue = 0, maxValue = Infinity, layout = 'vertical', supportingText, inputWidth = '104px' } = _a, props = __rest(_a, ["incrementAmount", "minValue", "maxValue", "layout", "supportingText", "inputWidth"]);
    // Formik connector
    // https://formik.org/docs/api/useField
    const [field, meta, helpers] = useField(props);
    const { value } = field;
    const { setValue, setTouched } = helpers;
    const decrementNumericalValue = (newValue) => {
        if (newValue <= minValue)
            return;
        else
            void setValue(newValue - incrementAmount);
    };
    const onDecrementHandler = () => {
        void setTouched(true);
        decrementNumericalValue(Number(value));
    };
    const isDecrementButtonDisabled = () => {
        return Number(value) <= minValue;
    };
    const incrementNumericalValue = (newValue) => {
        if (newValue >= maxValue)
            return;
        else
            void setValue(newValue + incrementAmount);
    };
    const onIncrementHandler = () => {
        void setTouched(true);
        incrementNumericalValue(Number(value));
    };
    const isIncrementerButtonDisabled = () => {
        return Number(value) >= maxValue;
    };
    const preventInvalidInput = (e) => {
        void setTouched(true);
        const allowedNonNumericKeys = ['Backspace', 'ArrowLeft', 'ArrowRight'];
        if (allowedNonNumericKeys.includes(e.key))
            return;
        else if (!isFinite(e.key)) {
            e.preventDefault();
        }
        return;
    };
    return (React.createElement(StyledInputStepper, { layout: layout, className: props.className },
        React.createElement(LabelSupportingTextWrapper, { supportingText: supportingText, layout: layout },
            React.createElement(StyledLabel, null, props.label),
            supportingText && (React.createElement(StyledSupportingLabel, null, supportingText))),
        React.createElement(InputStepperWrapper, null,
            React.createElement(StyledMinusButton, null,
                React.createElement(IconButton, { "aria-label": "decrement-button", variant: "primary", fill: "light", size: "regular", icon: "Minus", onClick: onDecrementHandler, disabled: isDecrementButtonDisabled() })),
            React.createElement(FieldErrorMessageWrapper, { inputWidth: inputWidth },
                React.createElement(StyledInternalTextInput, Object.assign({}, field, meta, { type: "number", onKeyDown: preventInvalidInput }, props))),
            React.createElement(StyledPlusButton, null,
                React.createElement(IconButton, { "aria-label": "increment-button", variant: "primary", fill: "light", size: "regular", icon: "Plus", onClick: onIncrementHandler, disabled: isIncrementerButtonDisabled() })))));
};
//# sourceMappingURL=InputStepper.js.map